/**
 * Css class for hidden fields
 */
export const FIELD_HIDDEN_CLASS = 'dynamic-form__field_is_hidden';
